import { cn } from "~/lib/utils";
import { dateDiff, formatDate } from "../helpers/date";
import { TriangleAlert } from "lucide-react";

interface DueDateCellProps {
  dueDate: string | null;
  renderedDate?: string;
  className?: string;
  showTriangleAlert?: boolean;
}

export const DueDateCell = ({
  dueDate,
  renderedDate,
  className,
  showTriangleAlert = true,
}: DueDateCellProps) => {
  const toDateDiff = dueDate ? dateDiff(dueDate, new Date(), "day") : null;
  const toDatePassed = toDateDiff !== null && toDateDiff < 0;
  const toDateClose = toDateDiff !== null && toDateDiff <= 5 && toDateDiff >= 0;

  return (
    <div
      className={cn(
        "flex items-center justify-between",
        {
          "text-warning-strong": toDateClose,
          "text-destructive": toDatePassed,
        },
        className,
      )}
    >
      {renderedDate ?? formatDate(dueDate)}
      {toDatePassed && showTriangleAlert && (
        <TriangleAlert className="text-destructive size-5" />
      )}
    </div>
  );
};
